import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-angle_down",
  "use": "rt-base-angle_down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-base-angle_down\"><defs><style type=\"text/css\"></style></defs><path d=\"M265.1 328H759c14.1 0 22.1 16.9 13.5 28.6L528.8 687.4c-8.4 11.5-25.1 11.5-33.5 0L251.6 356.6c-8.7-11.7-0.6-28.6 13.5-28.6z\" p-id=\"2760\" fill=\"#143E81\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/angle_down.svg
// module id = 1223
// module chunks = 116